<!-------------searching----------------
<div class="input-group Top SearchSize">
  <input type="search" class="form-control form-control-lg " placeholder="search customer" id="search" name="search" [(ngModel)]="search" (ngModelChange)="Search();">
  <div class="input-group-append">
  <button type="submit" class="btn btn-lg btn-default" (click)="Search();">
  <i class="fa fa-search"></i>
  </button>
  </div>
  </div>
--------------------------------new ui---------------------------------------------------->
<!-----test---------------------------------->
<div class="card-body">
  <div class="row">
    <div class="col-md-6">



      <div class="form-group">
        <label>Select Customer</label>
        <div class="input-group">
          <input type="search" class="form-control form-control-lg " placeholder="search customer" id="search"
            name="search" [(ngModel)]="search" (ngModelChange)="Search();">
          <div class="input-group-append">
            <button type="submit" class="btn btn-lg btn-default" (click)="Search();">
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-6">



      <div class="form-group">
        <label>Select Month</label>
        <div class="input-group">
          <input type="month" class="form-control form-control-lg " placeholder="search customer" id="search"
            name="search" [(ngModel)]="body.month_filter" (ngModelChange)="Search();" (click)="openDatePicker($event)">
          <div class="input-group-append">
            <button type="submit" class="btn btn-lg btn-default" (click)="Search();">
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group">



        <div class="form-group">
          <label>Select Employee</label>
          <div class="input-group">
            <input type="search" class="form-control form-control-lg" placeholder="Search employee"
              [(ngModel)]="search_data.employee_name" (ngModelChange)="SearchEmployee();">
            <button type="submit" class="btn btn-lg btn-default" (click)="SearchEmployee();">
              <i class="fa fa-search"></i>
            </button>

          </div>

          <div class="card card-default" *ngIf="isShownEmployee">
            <div *ngFor="let c of employee">
              <h4 class="font" (click)="getEmployeeId(c.employee_id,c.employee_name)"><b>{{c.employee_name}}</b></h4>
            </div>
          </div>


        </div>
      </div>
    </div>
  </div>

  <!----------------------------------------------->
  <section class="content-header ">

    <div class="row mb-2 ">
      <div class="col-sm-6">
        <h1>Sales Projections</h1>
      </div>
      <div class="col-sm-6 text-right">
        <button type="button" class="btn btn-success" data-toggle="modal" data-target="#excelModal"
          (click)="openExcelDialog()">
          <i class="fas fa-download"></i> Download Excel
        </button>
      </div>
    </div>

  </section>

  <!-- Excel Download Modal -->
  <div class="modal fade" id="excelModal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static"
    data-keyboard="false">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Download Sales Projection Report</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>Select Month</label>
            <input type="month" class="form-control" [(ngModel)]="excelMonth" name="excelMonth"
              (click)="openDatePicker($event)">
          </div>

          <div class="form-group">
            <label>Select User Type</label>
            <ng-select [items]="userTypedropdown" bindLabel="name" bindValue="name" placeholder="-- All User Types --"
              [(ngModel)]="selectedUserType" name="selectedUserType">
            </ng-select>
          </div>

          <div class="form-group">
            <label>Select Department</label>
            <select class="form-control" [(ngModel)]="selectedDepartment" name="selectedDepartment">
              <option value="">-- All Departments --</option>
              <option *ngFor="let dept of departmentDropdown" [value]="dept.department_id">{{ dept.department_name }}
              </option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" (click)="downloadExcel()" [disabled]="isDownloading || !excelMonth">
            <i class="fas fa-spinner fa-spin" *ngIf="isDownloading"></i>
            {{ isDownloading ? 'Downloading...' : 'Download' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="card card-default" *ngIf="filter_flag && CardShown">
    <table class="table style">

      <tbody>

        <tr>
          <td style="width: 25%"><b>Total Avg Sales :</b></td>
          <td style="width: 25%">{{AvgSale}}</td>
          <td style="width: 30%"><b>Total Agreed Sales :</b></td>
          <td style="width: 25%">{{ AgSales}}</td>
        </tr>

        <tr>
          <td style="width: 25%"><b>Total Active Receipts :</b></td>
          <td style="width: 25%">{{ AcReceipt}}</td>
          <td style="width: 25%"><b>Total Agreed Active Receipts :</b></td>
          <td style="width: 25%">{{AgAReceipt}}</td>
        </tr>

        <tr>
          <td style="width: 25%"><b>Total Inactive Receipts :</b></td>
          <td style="width: 25%">{{InReceipt}}</td>
          <td style="width: 25%"><b>Total Agreed Inactive Receipts :</b></td>
          <td style="width: 25%">{{ AgIReceipt}}</td>
        </tr>

      </tbody>
    </table>
  </div>

  <!--------------loader-------------------------->
  <div *ngIf=loaderShown class="loader"></div>
  <!----------------------------------------------->

  <section class="content">

    <div class="card" *ngIf=CardShown>
      <div class="card-header">

        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
            <i class="fas fa-minus"></i>
          </button>
          <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
      <div class="card-body p-0">
        <table class="table table-striped projects">
          <thead>
            <tr>


              <th style="width: 35%">
                Customer Name
              </th>

              <th style="width: 25%">
                Avg Sales Per Month
              </th>
              <!----
    <th style="width: 15%">
    Last 3 Month Sales
    </th>
   ----->

              <th style="width: 20%">
                Three Month Sales
              </th>

              <th>
              </th>

            </tr>
          </thead>
          <tbody>

            <tr *ngFor="let c of output">
              <td>
                <a>
                  {{c.customer_name}}
                </a>
              </td>
              <!----
    <td *ngIf="c.brand_images!='';else noImage"><img class="table-avatar" src="{{imgUrl+c.brand_images}}"></td>
    <ng-template #noImage>
      <td> </td>
    </ng-template>
  --->

              <td>
                {{c.avearage_sales_per_month | number:'1.2-2'}}
              </td>

              <!----
    <td>
    {{c.last_3_month_sales}}
    </td>
---->
              <td>
                {{c.last_3_month_sales | number:'1.2-2'}}
              </td>

              <td class="project-actions text-right">
                <a class="btn btn-primary btn-sm" data-toggle="modal" data-target="#modal-sm"
                  (click)="ViewDetail(c._id)">
                  <i class="fas fa-folder">
                  </i>
                  View
                </a>
                <!-------
    <a class="btn btn-info btn-sm left" (click)='getValue(c.brand_id);EditBrands()'>
    <i class="fas fa-pencil-alt">
    </i>
    Edit
    </a>
  
    <a class="btn btn-danger btn-sm" href="#">
    <i class="fas fa-trash">
    </i>
    Delete
    </a>
      --->
              </td>

            </tr>


          </tbody>
        </table>
      </div>

    </div>

  </section>
  <!---------pop up------------------------------------------------>
  <div class="modal fade top" id="modal-sm" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">

        <div class="modal-body">
          <label class="space">Agreed Target</label>
          <input type="text" class="form-control" [(ngModel)]="data.target" [readonly]="true">

          <label class="space">Agreed Receipts</label>
          <input type="text" class="form-control" [(ngModel)]="data.receiprs" [readonly]="true">

          <label class="space">Due Balance</label>
          <input type="text" class="form-control" [(ngModel)]="data.Due_balance" [readonly]="true">

          <label class="space">Manager</label>
          <input type="text" class="form-control" [(ngModel)]="data.manager" [readonly]="true">


          <label class="space">Status</label>
          <input type="text" class="form-control" [(ngModel)]="data.status" [readonly]="true">

        </div>


        <div class="modal-footer justify-content-between">

          <button type="button" class="btn btn-primary" style="margin-left: 40%;" data-dismiss="modal">Ok</button>

        </div>
      </div>
    </div>
  </div>


  <!---------------------paging------------------------------------->
  <ul class="pagination" *ngIf=CardShown>
    <li class="paginate_button page-item previous" id="example2_previous">
      <a (click)="clicks_previous()" aria-controls="example2" data-dt-idx="0" tabindex="0"
        class="page-link count">Previous</a>
    </li>

    <li class="paginate_button page-item "><a aria-controls="example2" data-dt-idx="1" tabindex="0"
        class="page-link count">{{ New_count+1}}</a></li>

    <li class="paginate_button page-item next" id="example2_next">
      <a (click)="clicks_next()" aria-controls="example2" data-dt-idx="7" tabindex="0" class="page-link">Next</a>
    </li>
  </ul>